import { Modal } from '@ori-ui/components';
import { styled, type Theme } from '@ori-ui/mui';

import { basePositionStyles } from '../../constants';
import { minibagWidthStyle } from '../MiniBag/styles';

const getStyles = (left: number | string, theme: Theme) =>
  ({
    ...basePositionStyles,
    display: 'block',
    left,
    position: 'fixed',
    textAlign: 'left',
    top: 'var(--top-nav-height, 0)',
    transition: `top var(--top-nav-height-animation, 0.3s ease-in-out)`,
    // top nav has appBar index and minibag (overlay) should go under it
    zIndex: theme.zIndex.appBar - 1,
  }) as const;

/** Used when minibag should be rendered as a popup after hovering the top navigation basket icon. */
export const ModalRoot = styled(Modal)<{
  ownerState: {
    isVisible: boolean;
  };
}>(({ ownerState: { isVisible }, theme }) => getStyles(isVisible ? 0 : 'auto', theme));

/** Displayed on wide screens for specific pages like eCatalogue. */
export const NonModalRoot = styled('div')(({ theme }) => getStyles(`calc(100vw - ${minibagWidthStyle})`, theme));
